export class Component {
    constructor(el, options = {}) { this.el = el; this.options = options; }
    async init(){

    }           // Setup/DOM lesen (SSR-ready)
    connected(){}            // Nach Init/Attach
    disconnected(){}         // Cleanup
    destroy(){ this.disconnected?.(); }
}